import type { ReactNode } from 'react';
import type { CountryCode } from 'libphonenumber-js/max';
import type { Control, FieldValues } from 'react-hook-form';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../form';
import { PhoneNumberInput } from '../phone-number-input';
import { Text } from '@folio/components/ui/text';

export type FormPhoneNumberInputProps = {
  control: Control<FieldValues>;
  label?: ReactNode;
  name: string;
  placeholder?: string;
  description?: ReactNode;
  required?: boolean;
  countries?: CountryCode[];
};

export { AsYouType as PhoneNumberValue } from 'libphonenumber-js/max';

export const FormPhoneNumberInput = ({
  control,
  label,
  name,
  placeholder,
  description,
  required,
  countries,
}: FormPhoneNumberInputProps) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field: { onChange, value, ...field } }) => {
        return (
          <FormItem>
            {!!label && (
              <FormLabel>
                {label}{' '}
                {required && (
                  <Text inline tone="destructive">
                    *
                  </Text>
                )}
              </FormLabel>
            )}
            <FormControl>
              <PhoneNumberInput
                placeholder={placeholder}
                name={field.name}
                ref={field.ref}
                onBlur={field.onBlur}
                value={value}
                countries={countries}
                required={required}
                onChange={onChange}
              />
            </FormControl>
            {!!description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
